module.exports = __webpack_public_path__ + "img/28_40.25ac7b57.png";